import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type ClaimState = {
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  lastCreatedClaimId: number | null;
};

const initialState: ClaimState = {
  isLoading: false,
  isError: false,
  isSuccess: false,
  lastCreatedClaimId: null,
};

const createClaimSlice = createSlice({
  name: 'createClaim',
  initialState: initialState,
  reducers: {
    createClaim: (_state, _: PayloadAction<{ claimSetId: number; insuranceProductId: number }>) => {},
    setLoadingClaimCreationStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    setClaimCreationError: (state) => {
      state.isError = true;
    },
    setClaimCreationSuccessful: (state) => {
      state.isSuccess = true;
    },
    setLastCreatedClaimId: (state, { payload }: PayloadAction<number>) => {
      state.lastCreatedClaimId = payload;
    },
    resetClaimCreation: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  createClaim,
  setLoadingClaimCreationStatus,
  setClaimCreationError,
  setClaimCreationSuccessful,
  resetClaimCreation,
  setLastCreatedClaimId,
} = createClaimSlice.actions;

export const createClaimReducer = createClaimSlice.reducer;
export const createClaimReducerPath = createClaimSlice.reducerPath;
